import { Doctor } from "@/types";

export const doctorsData: Doctor[] = [
  {
    id: 1,
    slug: "vladimira-nenco",
    appointment_url: "https://n1047281.alteg.io",
    country_code: "md",
  },
  {
    id: 2,
    slug: "iulian-gisca",
    appointment_url: "https://n1047278.alteg.io",
    country_code: "md",
  },
  {
    id: 3,
    slug: "gantuya-batbayar",
    appointment_url: "https://n1423053.alteg.io",
    country_code: "mn",
  },
  {
    id: 4,
    slug: "amgalan-batbaatar",
    appointment_url: "https://n1314495.alteg.io",
    country_code: "mn",
  },
  {
    id: 6,
    slug: "olga-cocebanu",
    appointment_url: "https://n1047276.alteg.io",
    country_code: "md",
  },
  {
    id: 7,
    slug: "odgerel-dashdendev",
    appointment_url: "https://n1190854.alteg.io",
    country_code: "mn",
  },
  {
    id: 8,
    slug: "vitalie-cocebanu",
    appointment_url: "https://n1047277.alteg.io",
    country_code: "md",
  },
  {
    id: 9,
    slug: "aliona-presneacova",
    appointment_url: "https://n1047282.alteg.io",
    country_code: "md"
  },
];
